import { setLoader, setDisableLoader } from "@/store/app/reducer";
import { createContext } from "react";
import store from "@/store";

export const LoaderContext = createContext({} as any);

export const LoaderContextProvider = ({ children }: any) => {
  const showLoader = (value: boolean) => {
    store.dispatch(setLoader(value));
  };

  return (
    <LoaderContext.Provider value={{ showLoader }}>
      {children}
    </LoaderContext.Provider>
  );
};

export const disableLoaderForOnce = () => {
  store.dispatch(setDisableLoader(true));
  setTimeout(() => store.dispatch(setDisableLoader(false))); // reset back after a delay
};
